// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__oWyiK","label":"styles_label__G2wV3"};